import {Component} from "@angular/core";

@Component({
  selector: "ui-logo",
  templateUrl: "./logo.component.html",
  styleUrls: ["./logo.component.scss"],
})
export class LogoComponent {}
